const t = {
  name: "AccountSwitch",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22 14C22 16.2091 20.2091 18 18 18H7.41406L10.4141 21L9 22.4141L3.58594 17L9 11.5859L10.4141 13L7.41406 16H18C19.1046 16 20 15.1046 20 14V11H22V14Z" fill="currentColor"/>
<path d="M20.4141 7L15 12.4141L13.5859 11L16.5859 8H6C4.89543 8 4 8.89543 4 10V13H2V10C2 7.79086 3.79086 6 6 6H16.5859L13.5859 3L15 1.58594L20.4141 7Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as AccountSwitch
};
